
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    title: {
      type: String,
      default: '',
    },
    showCallPhone: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
})
export default class IndexView extends Vue {
  onLeftClick() {
    this.$emit('left-click', '')
  }
  onRightClick() {
    this.$emit('right-click', '')
  }
}
